import { Autocomplete, FormControl, Grid2 as Grid, TextField } from "@mui/material";

type AutocompleteProps = {
    label: string,
    value: any,
    setValue: (v: any) => void,
    items: {[key: string]: any}[],
    disabled?: boolean,
    required?: boolean,
    size?: number
}

const FormAutocomplete = (
    { label, value, setValue, items, disabled = false, required = false, size = 4 }: AutocompleteProps
) => {
    const onFocus = (event: { target: { autocomplete: string; }; }) => {
        if(event.target.autocomplete) {
          event.target.autocomplete = "off";
        }
    }

    return (
        <Grid size={size}>
            <FormControl fullWidth>
                <Autocomplete
                    value={value}
                    onChange={(_event, newValue) => {
                        if (newValue) {
                            setValue(newValue);
                        }
                    }}
                    onInputChange={(_event, newInputValue) => {
                        if (newInputValue === "") {
                            setValue(null);
                        }
                    }}
                    options={items}
                    getOptionLabel={option => option.label ?? ""}
                    disabled={disabled}
                    renderInput={(params) => <TextField 
                        {...params}
                        label={label}
                        onFocus={onFocus}
                        required={required}
                    />}
                />
            </FormControl>
        </Grid>
    )
}

export default FormAutocomplete;
